import { IApiResponse } from "@interfaces/generic/IApiResponse.ts"
import { IPutUserResponseApi } from "@interfaces/IPutUserResponseApi.ts"
import { IPutUserResponseCli } from "@interfaces/IPutUserResponseCli.ts"

export const PutUserAdapter = (
	response: IApiResponse<IPutUserResponseApi>
): IPutUserResponseCli => {
	return response.data
}
